import '@/lib/sentry.js';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ThemeProvider from './utils/ThemeContext.jsx';
import { BrowserRouter as Router } from 'react-router-dom';
import notify from './utils/notify.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AxiosError } from 'axios';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 20, // 20 sec
    },
    mutations: {
      onError: (error) => {
        let message;

        if (!(error instanceof AxiosError)) return;

        if (error.request?.status === 400) message = 'Något gick fel. Se över dina uppgifter och försök igen!';
        if (error.request?.status === 401) message = 'Du är inte inloggad. Logga in och försök igen.';
        if (error.request?.status === 403) message = 'Du har inte behörighet att utföra denna åtgärd.';
        if (error.request?.status === 404) message = 'Resursen kunde inte hittas.';
        if (error.request?.status === 409) message = 'Resursen finns redan.';
        if (error.request?.status === 500) message = 'Något gick fel. Försök igen senare.';

        notify.error(message);
      },
      onSuccess: () => {
        notify.success('Klappat och klart!');
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <React.StrictMode>
      <Router>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <App />
            <ToastContainer className="" />
          </QueryClientProvider>
        </ThemeProvider>
      </Router>
    </React.StrictMode>
  </>,
);
